"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AppBar.default;
  }
});

var _AppBar = _interopRequireDefault(require("./AppBar"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/AppBar/index.js
 ** module id = 797
 ** module chunks = 0
 **/